import { useSelector } from 'react-redux'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { useFeature } from '@core/Utils/hooks'
import { getKambiSportsOfferingIntegrationOverrideSetting } from '@core/Areas/Settings/Store/selectors'

export function useNewSportsOfferingFeature() {
  const isKambiSportsOfferingFeatureActive = useFeature(
    FeatureFlags.KAMBI_SPORTS_OFFERING_INTEGRATION.key
  )
  const isLocallyEnabled = useSelector(getKambiSportsOfferingIntegrationOverrideSetting)

  const isKambiSportsOfferingEnabled = isKambiSportsOfferingFeatureActive && isLocallyEnabled

  return isKambiSportsOfferingEnabled
}
